import { useSelector } from 'react-redux';
import { RootState } from 'store';

const WelcomeHero = () => {
  const isDarkMode = useSelector((state: RootState) => state.theme.isDarkMode);

  return (
    <div className="text-text-primary space-y-6">
      <img
        src={!isDarkMode ? '/texttospeech-dark.png' : '/texttospeech-light.png'}
        alt=""
      />

      <h1 className="text-2xl md:text-5xl font-medium text-text-primary lg:leading-[60px] md:max-w-[400px] mb-2">
        Welcome to Text to Speech
      </h1>
      <p className="text-sm lg:text-xl font-normal text-text-primary md:w-[400px] mb-6 lg:mb-0">
        Convert your words into natural, lifelike speech with our advanced
        AI-powered tool. Effortlessly generate high-quality audio in multiple
        voices and languages, making your content more engaging and accessible.
        Bring your text to life with just a click!
      </p>
    </div>
  );
};

export default WelcomeHero;
